import React from 'react';
import './index.scss';

interface IMetricCardTitleProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export default function CommonLayout(props: IMetricCardTitleProps) {
  const { className = '', style, children, ...restProps } = props;

  return (<div
    className={`dbh-common-layout ${className}`}
    style={style}
  >
    {React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...restProps,
        state: {}
      }
    ))}
  </div>
  );
};
